import { EStockStatusValue } from '../interfaces/stock.interface';

const stockStatus = [
  { id: EStockStatusValue.IN_STOCK, name: 'In Stock' },
  { id: EStockStatusValue.REORDER_LEVEL, name: 'Re-Order Level' },
  { id: EStockStatusValue.MINIMUM_STOCK, name: 'Minimum Stock' },
];

const productTypes = [
  { id: 'PRODUCT', name: 'Product' },
  { id: 'KIT', name: 'Kit' },
];

export const StockConfig = {
  stockStatus,
  productTypes,
};
